import "./style.css";

setTimeout(async () => {
    const { default: cashPlugin } = await import("./plugins/cash");

    const { createApp } = await import("vue");
    const { default: router } = await import("./router");
    const { default: App } = await import("./App.vue");

    createApp(App).use(router).use(cashPlugin).mount("#app");
}, 1000); // 2000ms = 2 seconds
